function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
var BaggageIncluded = function BaggageIncluded(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 34 26",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08579 3.96079C9.46086 3.58571 9.96957 3.375 10.5 3.375H13.5C14.0304 3.375 14.5391 3.58571 14.9142 3.96079C15.2893 4.33586 15.5 4.84457 15.5 5.375V6.375H17.9062C18.6453 6.375 19.25 6.97106 19.25 7.71324V18.125V20.2868C19.25 20.9235 18.8049 21.4526 18.2118 21.5902C18.3947 21.8921 18.5 22.2462 18.5 22.625C18.5 23.7296 17.6046 24.625 16.5 24.625C15.3954 24.625 14.5 23.7296 14.5 22.625C14.5 22.2607 14.5974 21.9192 14.7676 21.625H9.23244C9.40261 21.9192 9.5 22.2607 9.5 22.625C9.5 23.7296 8.60457 24.625 7.5 24.625C6.39543 24.625 5.5 23.7296 5.5 22.625C5.5 22.2462 5.60528 21.8921 5.78818 21.5902C5.19506 21.4526 4.75 20.9235 4.75 20.2868V18.125V7.71324C4.75 6.97106 5.35471 6.375 6.09375 6.375H8.5V5.375C8.5 4.84457 8.71071 4.33586 9.08579 3.96079ZM5.75 18.625V20.2868C5.75 20.4705 5.90081 20.625 6.09375 20.625H7.5H16.5H17.9062C18.0992 20.625 18.25 20.4705 18.25 20.2868V18.625H5.75ZM18.25 17.625H5.75V7.71324C5.75 7.52952 5.90081 7.375 6.09375 7.375H9H15H17.9062C18.0992 7.375 18.25 7.52952 18.25 7.71324V17.625ZM15.5 22.625C15.5 22.0727 15.9477 21.625 16.5 21.625C17.0523 21.625 17.5 22.0727 17.5 22.625C17.5 23.1773 17.0523 23.625 16.5 23.625C15.9477 23.625 15.5 23.1773 15.5 22.625ZM7.5 21.625C6.94772 21.625 6.5 22.0727 6.5 22.625C6.5 23.1773 6.94772 23.625 7.5 23.625C8.05228 23.625 8.5 23.1773 8.5 22.625C8.5 22.0727 8.05228 21.625 7.5 21.625ZM14.5 5.375V6.375H9.5V5.375C9.5 5.10978 9.60536 4.85543 9.79289 4.66789C9.98043 4.48036 10.2348 4.375 10.5 4.375H13.5C13.7652 4.375 14.0196 4.48036 14.2071 4.66789C14.3946 4.85543 14.5 5.10978 14.5 5.375Z",
    fill: "#66797F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "1",
    width: "18",
    height: "18",
    rx: "9",
    fill: "#EAF5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 7.90039L23.1 12.1002L21 10.0004",
    stroke: "#319E37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "1",
    width: "18",
    height: "18",
    rx: "9",
    stroke: "white",
    strokeWidth: "2"
  }));
};
export default BaggageIncluded;